/* eslint-disable import/no-default-export */
export { default, LOCAL, SESSION, StorageProxy } from '@trello/storage';



// WEBPACK FOOTER //
// ./app/common/lib/storage.ts